import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface NameProps {
  name: string;
  url: string;
  className?: string;
}

export function Name({name, url, className}: NameProps) {
  return <h3 className={className ?? DetailsTooltipStyles.EntityName}><a href={url}>{name}</a></h3>;
}